module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABzSURBVHgBfY5RDYAwDERLQAA4GA6QggNwAg7AAaBkNvgbEnAwbsk1LAvskre0XZu7Ul5NoAGn/GgBHlhgEmph4TO4Cs9NwsUFjsTFadGx2aLPWj4UD3cehWMpwMhcsQbOQoxWPXPBjdqYBMuFVTLqwazNAyMXIcltfk21AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/transfer-ownership-icon-black-2.png
// module id = 3406
// module chunks = 0